<div class="container text-center vh-100">
	<div
		class="d-flex flex-column align-items-center justify-content-center vh-100"
	>
		<img
			class="img-fluid img-logo bounce-animation"
			src="/assets/images/baseerp.svg"
		/>
		<div>
			<div class="progress-bar fade-animation">
				<div class="bar"></div>
			</div>
			<p class="text-primary fade-animation p-4">
				Dentro de alguns instantes você será direcionado para o Base by
				Asaas.
			</p>
		</div>
	</div>
</div>
